import { ToggleOption } from 'sharedComponents/Buttons/types';
import { VacancyModalPane } from './types';

export const VacancyModalKind = { DISTRICT: 'district', SCHOOL: 'school' } as const;

export const districtOption: VacancyModalPane = {
  id: 1,
  title: 'District vacancies',
  type: VacancyModalKind.DISTRICT,
};

export const schoolOption: VacancyModalPane = {
  id: 0,
  title: 'School-based vacancies',
  type: VacancyModalKind.SCHOOL,
};

export const schoolVacancyOptions = [
  {
    id: 0,
    title: 'School',
  },
  { id: 1, title: 'Group' },
];

export const toggleOptions: ToggleOption[] = [schoolOption, districtOption];

export const SCHOOLROLES_FORM_ID = 'schoolroles';
